import { render, staticRenderFns } from "./AddTourVideo.vue?vue&type=template&id=6bf36e44"
import script from "./AddTourVideo.vue?vue&type=script&lang=js"
export * from "./AddTourVideo.vue?vue&type=script&lang=js"
import style0 from "./AddTourVideo.vue?vue&type=style&index=0&id=6bf36e44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports